(function() {
  // Listen for cart updates to check if we need to remove a customization
  function checkCartForCustomization() {
    console.log("Checking cart for customizations...");
    // Fetch the cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        for (const item of cart.items) {
          if (item.properties && item.properties['_personnalisation_ID']) {
            // If a customization is found, check if it needs to be removed
            const customizationId = item.properties['_personnalisation_ID'];

            if (cart.items.filter(item => item.properties['_personnalisation_ID'] ===  customizationId).length !== 2) {
              // If the count is not 2, remove the customization
              fetch(KROWN.settings.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              }).then(response => {
                console.log(`PING`, response);
                if (response.ok) {
                  console.log(`Customization with ID ${customizationId} removed from cart.`);
                } else {
                  console.error(`Failed to remove customization with ID ${customizationId} from cart.`);
                }
                setTimeout(() => {
                  if (window.location.pathname.includes("cart")) {
                    window.location.reload();
                  } else {
                    window.refreshCart();
                  }
                }, 500);
              });
            }
          }
        }
      });
  }
  
  const cartForm = document.getElementById('AjaxCartForm');
  if (cartForm) {
    cartForm.addEventListener('cart-updated', (e) => {
      checkCartForCustomization();
    });
  }
  checkCartForCustomization();
})();